import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const TradingViewIcon = createValidIcon((props) => {
  const { disabled, size = 40 } = props

  if (disabled) {
    return (
      <svg
        width={size}
        height={size}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect width='40' height='40' rx='20' fill='#222222' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24.5264 16.5818C24.5264 18.0077 23.3829 19.1636 21.9724 19.1636C20.5618 19.1636 19.4183 18.0077 19.4183 16.5818C19.4183 15.1559 20.5618 14 21.9724 14C23.3829 14 24.5264 15.1559 24.5264 16.5818ZM18.1562 14.1822H8V19.3458H13.0481V27H18.1562V14.1822ZM27.1106 14.1822H33L27.6815 27H21.7921L27.1106 14.1822Z'
          fill='white'
        />
      </svg>
    )
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='40' rx='20' fill='#131722' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.5264 16.5818C24.5264 18.0077 23.3829 19.1636 21.9724 19.1636C20.5618 19.1636 19.4183 18.0077 19.4183 16.5818C19.4183 15.1559 20.5618 14 21.9724 14C23.3829 14 24.5264 15.1559 24.5264 16.5818ZM18.1562 14.1822H8V19.3458H13.0481V27H18.1562V14.1822ZM27.1106 14.1822H33L27.6815 27H21.7921L27.1106 14.1822Z'
        fill='white'
      />
    </svg>
  )
})
